/**
 * Productformulier, variantselectie en galerij.
 *
 * Bij het wisselen van variant wordt de prijs, voorraad en knopstatus
 * opgehaald via Shopify's Section Rendering API. Zo komt de prijsopmaak
 * altijd van Shopify zelf en klopt die ook in andere markten en valuta.
 */
(function () {
  'use strict';

  // Voorkomt dubbele initialisatie wanneer dit bestand twee keer wordt ingeladen.
  if (window.__themeProductForm) return;
  window.__themeProductForm = true;

  /* ------------------------------------------------------------------
     Galerij
     ------------------------------------------------------------------ */

  function initGallery(gallery) {
    var slides = gallery.querySelectorAll('[data-media-id]');
    var thumbs = gallery.querySelectorAll('[data-media-target]');

    function show(mediaId) {
      slides.forEach(function (slide) {
        slide.hidden = slide.dataset.mediaId !== String(mediaId);
      });
      thumbs.forEach(function (thumb) {
        thumb.setAttribute('aria-current', thumb.dataset.mediaTarget === String(mediaId) ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        show(thumb.dataset.mediaTarget);
      });
    });

    gallery.showMedia = show;
  }

  /* ------------------------------------------------------------------
     Variantselectie
     ------------------------------------------------------------------ */

  function ProductVariants(form) {
    this.form = form;
    this.sectionId = form.dataset.sectionId;
    this.picker = document.querySelector('[data-variant-picker]');
    this.variantInput = form.querySelector('[data-variant-id]');
    this.variants = this.readVariants();

    // Het verborgen veld staat in de HTML uit om te voorkomen dat er zonder
    // JavaScript twee velden met de naam 'id' worden verstuurd. Nu JavaScript
    // draait, nemen wij de variantkeuze over en mag het veld aan.
    if (this.variantInput) this.variantInput.disabled = false;

    if (!this.picker || !this.variants) return;

    this.bindEvents();
  }

  ProductVariants.prototype.readVariants = function () {
    var script = document.querySelector('[data-variant-data="' + this.sectionId + '"]');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  };

  ProductVariants.prototype.bindEvents = function () {
    var self = this;
    this.picker.querySelectorAll('[data-option-selector]').forEach(function (input) {
      input.addEventListener('change', self.onChange.bind(self));
    });
  };

  ProductVariants.prototype.selectedOptions = function () {
    var values = [];
    this.picker.querySelectorAll('.variant-picker__group').forEach(function (group) {
      var checked = group.querySelector('[data-option-selector]:checked');
      values.push(checked ? checked.value : null);
    });
    return values;
  };

  ProductVariants.prototype.findVariant = function (options) {
    return this.variants.filter(function (variant) {
      return options.every(function (value, index) {
        return variant.options[index] === value;
      });
    })[0];
  };

  ProductVariants.prototype.onChange = function () {
    var options = this.selectedOptions();
    var variant = this.findVariant(options);

    // Toon het gekozen woord naast de optienaam
    this.picker.querySelectorAll('[data-option-value]').forEach(function (label, index) {
      if (options[index]) label.textContent = options[index];
    });

    if (!variant) {
      this.setUnavailable();
      return;
    }

    if (this.variantInput) this.variantInput.value = variant.id;
    this.updateUrl(variant.id);
    this.updateMedia(variant);
    this.refreshSection(variant.id);
  };

  ProductVariants.prototype.setUnavailable = function () {
    var button = this.form.querySelector('[data-add-button]');
    var text = this.form.querySelector('[data-add-button-text]');
    if (button) button.disabled = true;
    if (text) text.textContent = window.theme.strings.unavailable;
  };

  ProductVariants.prototype.updateUrl = function (variantId) {
    if (!window.history.replaceState) return;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url.toString());
  };

  ProductVariants.prototype.updateMedia = function (variant) {
    var gallery = document.querySelector('[data-product-gallery]');
    if (gallery && gallery.showMedia && variant.featured_media) {
      gallery.showMedia(variant.featured_media.id);
    }
  };

  /**
   * Haalt prijs, voorraad en knopstatus opnieuw op bij Shopify.
   */
  ProductVariants.prototype.refreshSection = function (variantId) {
    var self = this;
    var url = window.location.pathname + '?variant=' + variantId + '&section_id=' + this.sectionId;

    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');

        ['[data-price-container]', '[data-inventory-container]', '[data-buy-buttons]'].forEach(function (selector) {
          var incoming = parsed.querySelector(selector);
          var existing = document.querySelector(selector);
          if (incoming && existing) {
            existing.innerHTML = incoming.innerHTML;
          }
        });

      })
      .catch(function () {
        // Netwerkfout: de knop blijft werken met de geselecteerde variant.
      });
  };

  /* ------------------------------------------------------------------
     Toevoegen aan winkelmand
     ------------------------------------------------------------------ */

  function handleSubmit(event) {
    var form = event.target;
    if (!form.matches('[data-product-form]')) return;

    // Zonder fetch-ondersteuning gewoon normaal versturen naar Shopify.
    if (!window.fetch) return;

    event.preventDefault();

    var button = form.querySelector('[data-add-button]');
    var buttonText = form.querySelector('[data-add-button-text]');
    var errorBox = form.querySelector('[data-form-error]');
    var originalText = buttonText ? buttonText.textContent : '';

    if (button) button.disabled = true;
    if (buttonText) buttonText.textContent = window.theme.strings.adding;
    if (errorBox) errorBox.hidden = true;

    var formData = new FormData(form);
    formData.append('sections_url', window.location.pathname);

    fetch(window.theme.routes.cartAdd, {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: formData
    })
      .then(function (response) {
        return response.json().then(function (body) {
          if (!response.ok) throw new Error(body.description || body.message);
          return body;
        });
      })
      .then(function () {
        if (buttonText) buttonText.textContent = window.theme.strings.added;
        document.dispatchEvent(new CustomEvent('cart:updated'));

        if (window.theme.cartType === 'drawer') {
          document.dispatchEvent(new CustomEvent('cart:open'));
        }

        setTimeout(function () {
          if (buttonText) buttonText.textContent = originalText;
          if (button) button.disabled = false;
        }, 1200);
      })
      .catch(function (error) {
        if (errorBox) {
          errorBox.textContent = error.message || window.theme.strings.addError;
          errorBox.hidden = false;
        }
        if (buttonText) buttonText.textContent = originalText;
        if (button) button.disabled = false;
      });
  }

  /* ------------------------------------------------------------------
     Initialisatie
     ------------------------------------------------------------------ */

  function init() {
    document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      initGallery(gallery);
    });

    document.querySelectorAll('[data-product-form][data-section-id]').forEach(function (form) {
      if (form.dataset.variantsReady) return;
      form.dataset.variantsReady = 'true';
      new ProductVariants(form);
    });
  }

  document.addEventListener('submit', handleSubmit);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
